import React, { useState } from 'react';
import { ExternalLinkIcon } from 'lucide-react';
export const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const projects = [{
    title: 'E-commerce App Redesign',
    description: 'Complete UI/UX redesign for an e-commerce platform, focusing on improved user flow and conversion optimization. Created wireframes, prototypes, and final designs.',
    tags: ['UI Design', 'UX Research', 'Prototyping'],
    category: 'UI/UX',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }, {
    title: 'Brand Identity System',
    description: 'Developed a comprehensive brand identity system including logo design, typography guidelines, color palette, and application examples for a tech startup.',
    tags: ['Branding', 'Logo Design', 'Style Guide'],
    category: 'Graphic Design',
    image: 'https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }, {
    title: 'Photo Manipulation Series',
    description: 'Created a series of conceptual photo manipulations combining multiple images into seamless, surreal compositions with advanced editing techniques.',
    tags: ['Photo Editing', 'Compositing', 'Creative Direction'],
    category: 'Photo Editing',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }, {
    title: 'Mobile Banking App',
    description: 'Designed a user-friendly mobile banking application with focus on accessibility and security. Created user flows, wireframes and high-fidelity prototypes.',
    tags: ['UI Design', 'Mobile App', 'Prototyping'],
    category: 'UI/UX',
    image: 'https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }, {
    title: 'Social Media Campaign',
    description: 'Designed a cohesive social media campaign including post templates, stories, and promotional materials with consistent visual language.',
    tags: ['Graphic Design', 'Social Media', 'Marketing'],
    category: 'Graphic Design',
    image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }, {
    title: 'Product Photography Editing',
    description: 'Professional product photo editing for an e-commerce catalog, including background removal, color correction, and retouching.',
    tags: ['Photo Editing', 'Product Photography', 'Retouching'],
    category: 'Photo Editing',
    image: 'https://images.unsplash.com/photo-1565814329452-e7ced9b5b8b0?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80'
  }];
  const filters = ['All', 'UI/UX', 'Graphic Design', 'Photo Editing'];
  const filteredProjects = activeFilter === 'All' ? projects : projects.filter(project => project.category === activeFilter);
  return <section id="projects" className="py-20 px-6 md:px-12 bg-black bg-opacity-80" data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center" data-id="element-155">
          My Projects
        </h2>
        <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-156">
          {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-6 py-2 rounded-full transition-all ${activeFilter === filter ? 'bg-purple-600 text-white' : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`} data-id="element-157">
              {filter}
            </button>)}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-158">
          {filteredProjects.map((project, index) => <div key={index} className="bg-gray-900 rounded-xl overflow-hidden group hover:transform hover:scale-105 transition-all duration-300" data-id="element-159">
              <div className="h-48 overflow-hidden" data-id="element-160">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-161" />
              </div>
              <div className="p-6" data-id="element-162">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-163">
                  {project.title}
                </h3>
                <p className="text-gray-400 mb-4" data-id="element-164">{project.description}</p>
                <div className="flex flex-wrap gap-2 mb-4" data-id="element-165">
                  {project.tags.map((tag, tagIndex) => <span key={tagIndex} className="px-3 py-1 bg-purple-900 bg-opacity-50 rounded-full text-xs text-purple-200" data-id="element-166">
                      {tag}
                    </span>)}
                </div>
                <a href="#" className="inline-flex items-center text-purple-400 hover:text-purple-300" data-id="element-167">
                  View Project <ExternalLinkIcon size={16} className="ml-1" data-id="element-168" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};